import { useGlobalStore } from "@/stores/global";

export default defineNuxtPlugin(nuxtApp => {
  // called right before setting a new locale
  nuxtApp.hook('i18n:beforeLocaleSwitch', async({ oldLocale, newLocale, initialSetup, context }) => {
     await useGlobalStore().registerGlobalData(newLocale);
  })
})
